
export default {
  path:'/account',
  props:true,
  redirect: {name:'login'},
  component:() => import('../pages/account/s'),
  children:[
    {
      path:'register',
      name:'register',
      component:() => import('../pages/account/register')
    },
    {
      path:'login',
      name:'login',
      component:() => import('../pages/account/login')
    },
    {
      path:'forgetpwd',
      name:'forgetpwd',
      component:() => import('../pages/account/forgetpwd')
    }
  ]
}